import React, { useCallback } from 'react';
import type { IssueId } from '@atlassian/jira-shared-types';
import { RoadmapBarIcon } from '@atlassian/jira-software-roadmap-timeline-table-kit';
import type { Position } from '@atlassian/jira-software-roadmap-timeline-table-kit/src/types';

type Props = {
	hasImplicitDependency: boolean;
	level: number;
	dependencies: IssueId[];
	dependees: IssueId[];
	onClickIcon: (fromIds: IssueId[], toIds: IssueId[], position: Position) => void;
};

const BarIcon = ({ level, dependencies, dependees, hasImplicitDependency, onClickIcon }: Props) => {
	const onClick = useCallback(
		(position: Position) => {
			onClickIcon(dependencies, dependees, position);
		},
		[dependencies, dependees, onClickIcon],
	);

	if (dependencies.length === 0 && dependees.length === 0 && !hasImplicitDependency) {
		return null;
	}

	return <RoadmapBarIcon level={level} onClick={onClick} />;
};

export default BarIcon;
